import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Textarea, Tooltip, Typography } from "@mui/joy";
import React, { useState, useEffect, useContext, useCallback } from "react"
import { AlertContext } from '../../context/AlertFlag';
import { copyToClipboard } from '../../utils/Clipboard';
import { capitalizeWords } from '../../utils/FormatNoteNameAndText';
import PropTypes from "prop-types";

export function NoteDisplayCard({note, liftTitles, createRefAtIndex, assignedRefs, parentEditable, liftParts}) {
    const { addAlert } = useContext(AlertContext);

    const [titles, setTitles] = useState([]);
    const [parts, setParts] = useState([]);
    const [editable, setEditable] = useState(false);

    useEffect(() => {
        setEditable(parentEditable);
    }, [parentEditable])

    // Can look for better way to handle current system
    // Aggressively clean -> Deallocate dynamic references at lowest and highest level to mark collection for garbage collector
    useEffect(() => {
        const indexMarkdown = () => {
            const text = `Ensure start ${note}`
            let match;
            const titles = [];
            const regex = /\*\*([^*]+)\*\*/g;
            let parts = [];
        
            while ((match = regex.exec(text)) !== null) {
                titles.push(match[1]);
            }
            liftTitles(titles);

            let lastIndex = 0;
            let refsIndex = 0;
            for (let i = 0; i < titles.length; i++) {
                const title = titles[i];
                const index = text.indexOf(`**${title}**`, lastIndex) - 1;
                if (index !== -1) {
                    parts.push(text.substring(lastIndex, index).trim());
                    createRefAtIndex(refsIndex);
                    refsIndex += 1;
                    lastIndex = index + title.length + 6; 
                }
            }
        
            // Add the last part of the text - No need for ref as ref already has adequate from ensured start
            if (lastIndex < text.length) {
                parts.push(text.substring(lastIndex).trim());
            }
        
            // Remove start
            parts = parts.slice(1);
            setParts(parts);
            setTitles(titles);
            liftParts(parts);
        }
        indexMarkdown();
        return () => {
            assignedRefs.forEach((ref, i) => {
                if (ref?.current) {
                assignedRefs[i].current = null;
                }
            });
        };
    }, [note]);
      
    return <>
        {(titles.map((title, index) => {
            return <div key={`${title} ${index}`}>
             <div style={{marginBottom: '4px', display: "flex"}}>
                <Typography level="body-lg" sx={{alignSelf: "center", m: 0, fontSize: '1.125rem'}}>
                    {capitalizeWords(title.toLowerCase(), ' ')}
                </Typography>
                {!editable && <Tooltip title="Copy section" size="sm">
                    <IconButton onClick={() => {
                        addAlert("Section Copied!", "success")
                        copyToClipboard(parts[index]);
                        }} sx={{ width: "fit-content", alignSelf: "center"}}>
                        <ContentCopyIcon fontSize="lg"/>
                    </IconButton>
                </Tooltip>}
            </div>
            <Textarea
            key={`textarea-${index}`}
            defaultValue={parts[index]}
            slotProps={{ textarea: { ref: assignedRefs[index] } }}
            variant="plain"
            size="sm"
            sx={{ backgroundColor: "white" }}
            readOnly={editable ? false : true}
            />
            </div>
        })
        )}
    </>
}

NoteDisplayCard.propTypes = {
    noteTitles: PropTypes.arrayOf(PropTypes.string).isRequired,
    noteText: PropTypes.arrayOf(PropTypes.string).isRequired,
    parentEditable: PropTypes.bool.isRequired,
    assignRefs: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export function pureTitleAndParts(noteUnformatted) {
    const text=`Ensure start ${noteUnformatted}`;
    let match;
    const titles = [];
    const regex = /\*\*([^*]+)\*\*/g;
    let parts = [];


    while ((match = regex.exec(text)) !== null) {
        titles.push(match[1]);
    }

    let lastIndex = 0;
    for (let i = 0; i < titles.length; i++) {
        const title = titles[i];
        const index = text.indexOf(`**${title}**`, lastIndex) - 1;
        if (index !== -1) {
            parts.push(text.substring(lastIndex, index).trim());
            lastIndex = index + title.length + 6; 
        }
    }

    // Add the last part of the text
    if (lastIndex < text.length) {
        parts.push(text.substring(lastIndex).trim());
    }

    // Remove start
    parts = parts.slice(1);

    return {
        "titles": titles,
        "parts": parts
    }
}